import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { StarRating } from './star-rating/star-rating';
import * as styles from '../average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StarRatingDisplay = _ref => {
  var rating = _ref.rating,
    fillStar = _ref.fillStar,
    starSize = _ref.starSize,
    starGap = _ref.starGap,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth;
  return ___EmotionJSX(StackItem, {
    css: styles.starRating,
    align: "center"
  }, ___EmotionJSX(StarRating, {
    rating: rating,
    fillStar: fillStar,
    starSize: starSize,
    starGap: starGap,
    strokeColor: strokeColor,
    strokeWidth: strokeWidth
  }));
};
export default StarRatingDisplay;